module.exports = __webpack_public_path__ + "img/tire-care-no.bde187ea.svg";